export default __webpack_public_path__ + "static/media/hermes_915_hero.55751219.jpg";